export enum ProgressStep {
    Begin,
    GetApplication,
    GetIcaFile,
    SessionStart,
    ClientConnecting,
    ClientConnected,
    ClientSessionReady,
    ClientSessionResized,
    RemoveOverlay
}
